import request from '@/request/index'

// 获取新闻列表
export function getNewsList(product, query = {}) {
  return request.get('/anon/news', {
    ...product,
    ...query,
    ...{desc:'public_time'}
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取新闻详情 anon/news/1892464288665120769
export function getNewsDetail(id, data) {
  return request.get( `/anon/news/${id}` , data, {
    headers: {
      'Content-Type': 'application/json'
    }
    }
  )
}

// 获取新闻分类树
export function getNewsTypeTree() {
  return request.get('/anon/newsTypeTree', {}, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
} 